export default "__VITE_ASSET__BOEEaIm___"